import RequestHandler from "./request-handler";
class RadiatorReplaceListService {
    constructor() {
        this.path = "RadiatorReplace";
        if (RadiatorReplaceListService.instance) {
            return RadiatorReplaceListService.instance;
        }
        RadiatorReplaceListService.instance = this;
        return this;
    }
    async get() {
        return await RequestHandler.get(this.path);
    }
    async getByAllocatorIdAndDate(id, date) {
        return await RequestHandler.getWithParams(this.path + '/getByAllocatorIdAndDate', {
            allocatorId: id,
            date: date
        });
    }
    async insert(data) {
        return await RequestHandler.post(this.path, data);
    }
    async update(data) {
        return RequestHandler.put(this.path, data);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
}
const instance = new RadiatorReplaceListService();
export default instance;